<template>
  <v-dialog v-model="dialog" max-width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        rounded
        v-on="on"
        v-bind="attrs"
        height="32"
        :block="isMobile()"
        :text="!isMobile()"
        :outlined="isMobile()"
        ><v-icon left>mdi-filter-outline</v-icon>Filtrar pedidos</v-btn
      >
    </template>
    <v-card :loading="loading">
      <v-card-title class="font-weight-bold">Filtrar Pedidos</v-card-title>
      <v-card-text>
        <v-row dense class="mt-3">
          <v-col cols="12">
            <v-select
              :items="filiais"
              item-text="descricao"
              item-value="filial"
              label="Selecionar filial"
              v-model="filtro.filial"
            >
              <template v-slot:item="{ item }">
                {{ item.filial }} - {{ item.descricao }}
              </template>
              <template v-slot:selection="{ item }">
                {{ item.filial }} - {{ item.descricao }}
              </template>
            </v-select>
          </v-col>
          <v-col xl="6" lg="6" md="6" cols="12">
            <v-text-field
              label="Data inicial emissão"
              type="date"
              v-model="filtro.dtiniemissao"
            ></v-text-field>
          </v-col>
          <v-col xl="6" lg="6" md="6" cols="12">
            <v-text-field
              label="Data final emissão"
              type="date"
              v-model="filtro.dtfimemissao"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <v-select
              label="Status"
              :items="status"
              item-text="descricao"
              item-value="statuscod"
              v-model="filtro.status"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          rounded
          color="success"
          text
          @click="buscarPedidos()"
          :loading="filtrando"
          >Buscar pedidos</v-btn
        >
        <v-btn rounded color="secondary" text @click="dialog = false"
          >Cancelar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";
export default {
  computed: {
    ...mapState("pedidos", ["status"]),
    ...mapState("base", ["filiais"]),
    ...mapState("usuario", ["usuarioLogado"]),
  },
  data: () => ({
    dialog: false,
    loading: true,
    filtrando: false,
    filtro: {
      filial: 0,
      dtiniemissao: "",
      dtfimemissao: "",
      status: 0,
    },
  }),
  methods: {
    ...mapActions("pedidos", ["getStatusPedido", "getPedidos"]),
    ...mapActions("base", ["getFiliais"]),
    isMobile() {
      return this.$mq == "sm";
    },
    async buscarPedidos() {
      this.filtrando = true;
      await this.getPedidos(this.filtro);
      this.filtrando = false;
      this.dialog = false;
    },
  },
  async mounted() {
    this.loading = true;

    await this.getFiliais();
    await this.getStatusPedido();

    this.filtro.dtiniemissao = moment()
      .subtract(this.usuarioLogado.representante ? 15 : 3, "days")
      .format("YYYY-MM-DD");
    this.filtro.dtfimemissao = moment().format("YYYY-MM-DD");
    this.loading = false;
  },
};
</script>

<style>
</style>